"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var messages = {
  de: {
    sprinxFormsValidation: {
      required: 'Pflichtfeld!',
      string: 'Muss eine Textzeichenfolge sein!',
      stringEmpty: 'Darf nicht leer bleiben!',
      stringMin: 'Die Länge muss größer oder gleich der Länge von {expected} Zeichen sein!',
      stringMax: 'Die Länge muss kleiner oder gleich der Länge von {expected} Zeichen sein!',
      stringLength: 'Die Länge muss {expected} Zeichen lang sein!',
      stringPattern: 'Entspricht nicht dem erforderlichen Muster!',
      stringContains: "Muss den Text '{expected} 'enthalten!",
      stringEnum: 'Entspricht keinem der zulässigen Werte!',
      number: 'Muss eine Nummer sein!',
      numberMin: 'Muss größer oder gleich sein {expected}!',
      numberMax: 'Muss kleiner oder gleich sein {expected}!',
      numberEqual: 'Muss gleich sein {expected}!',
      numberNotEqual: 'Darf nicht gleich sein {expected}!',
      numberInteger: 'Muss eine ganze Zahl sein!',
      numberPositive: 'Muss eine positive Zahl sein!',
      numberNegative: 'Muss eine negative Zahl sein!',
      array: 'Es muss eine Liste sein!',
      arrayEmpty: 'Die Liste darf nicht leer sein!',
      arrayMin: 'Es ist erforderlich mindestens {number, plural, eine {1 položka} mehrere {{number} položky} andere {{number} položek}}!',
      arrayMax: 'Darf nicht mehr enthalten als Nemůže obsahovat více než {number, plural, eine {1 položku} mehrere {{number} položky} andere {{number} položek}}!',
      arrayLength: 'Muss enthalten genau {expected, plural, eine {1 položku} mehrere {{number} položky} andere {{number} položek}}!',
      arrayContains: "Muss den Artikel enthalten '{expected}'!",
      arrayEnum: "Wert '{expected}' stimmt mit keinem der zulässigen Werte überein!",
      boolean: "Muss 'ja' oder 'nein' sein!",
      function: 'Muss eine Funktion sein!',
      date: 'Muss ein Datum sein!',
      dateMin: 'Muss größer oder gleich sein {expected}!',
      dateMax: 'Muss kleiner oder gleich sein {expected}!',
      forbidden: 'Feld ist verboten!',
      email: 'falsche E-mail!',
      url: 'falsche URL!',
      object: 'Muss ein Objekt sein!',
      arrayReducedEquals: 'Der zusammengefaste Wert stimmt nicht überein {expected}!',
      phoneNumber: "Muss eine gültige Telefonnummer im internationlen Format '+ XXX XXX XXX XXX 'sein!",
      dateGt: 'Datum muss größer sein als {expected}!',
      dateGte: 'Datum muss größer oder gleich sein als {expected}!',
      dateLt: 'Datum muss kleiner sein als {expected}!',
      dateLte: 'Datum muss kleiner oder gleich sein als {expected}!'
    }
  }
};
var _default = messages;
exports.default = _default;